import { FetchResult, useMutation } from '@apollo/client';

import { CreateLearningLoopReflectionDocument } from '@/store/v2';
import { CreateLearningLoopReflectionInput, CreateLearningLoopReflectionResult } from './types';
import { LEARNING_LOOPS_QUERY_OPERATION_NAME } from './useLearningLoops';

export const useCreateLearningLoopReflection = (): {
  createLearningLoopReflection: (
    input: CreateLearningLoopReflectionInput,
  ) => Promise<FetchResult<{ createLearningLoopReflection: CreateLearningLoopReflectionResult }>>;
  loading: boolean;
  error: boolean;
} => {
  const [createLearningLoopReflection, { loading, error }] = useMutation<{
    createLearningLoopReflection: CreateLearningLoopReflectionResult;
  }>(CreateLearningLoopReflectionDocument, {
    refetchQueries: [LEARNING_LOOPS_QUERY_OPERATION_NAME],
  });

  return {
    createLearningLoopReflection: async (input: CreateLearningLoopReflectionInput) =>
      createLearningLoopReflection({
        variables: { input },
      }),
    loading,
    error: !!error,
  };
};
